<div #contentWrapper class="outer-container" [ngClass]="{'is-vertical': isVertical, 'is-horizontal': !isVertical}"
    [ngStyle]="{'max-height': (isVertical ? panelSizeInPixels + 'px' : null), 'max-width': (!isVertical ? panelSizeInPixels + 'px' : null), 'opacity': (panelSizeInPixels ? 1 : 0)}">
        <ng-content></ng-content>
</div>
